import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";
import _remove from "lodash/remove";
import { User } from "@/Models";
import { useApiStore } from "@/store/hooks";

export const CONSTANTS = {
  SET_USERS_CACHE: "SET_USERS_CACHE",
};

const INITIAL_STATE = {
  usersCache: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.SET_USERS_CACHE:
      return {
        ...state,
        usersCache: action.usersCache,
      };

    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useUsersStore = () => {
  const api = useApiStore();
  const { dispatch, state } = useContext(Context);

  const fetchByIdOnTheFly = useCallback(
    async (id) => {
      const user = await api.get(`/users/${id}`);

      const _usersCache = [...state.usersCache];

      if (_usersCache.find((u) => u.id === user.id)) {
        _usersCache.splice(
          _usersCache.findIndex((u) => u.id === user.id),
          1,
          new User(user),
        );
      } else {
        _usersCache.push(new User(user));
      }

      dispatch({
        type: CONSTANTS.SET_USERS_CACHE,
        usersCache: _usersCache,
      });

      return new User(user);
    },
    [api.get, state.usersCache],
  );

  return {
    state,
    fetchByIdOnTheFly,
  };
};
